import { render, staticRenderFns } from "./projectBigScreen.vue?vue&type=template&id=40d79e1f&scoped=true&"
import script from "./projectBigScreen.vue?vue&type=script&lang=js&"
export * from "./projectBigScreen.vue?vue&type=script&lang=js&"
import style0 from "./projectBigScreen.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./projectBigScreen.vue?vue&type=style&index=1&id=40d79e1f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d79e1f",
  null
  
)

export default component.exports